// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","BrandListItem__icon":"uw_a bhl_kb","BrandListItem__name":"uw_b bhl_vn"};